import { ZoneContextManager } from '@opentelemetry/context-zone';
import { CompositePropagator, W3CTraceContextPropagator } from '@opentelemetry/core';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ATTR_SERVICE_NAME, SEMRESATTRS_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { authTokenManager } from '../../authentication';
import { CustomSpanMetricProcessor } from '../config/CustomSpanMetricProcessor';
import { traceSpanMetricNormalize } from './traceSpanMetricNormalize';

export const TRACER_NAME = 'application';
export const RESOURCE_NAME = 'taboola-ads';

const OPEN_TELEMETRY_EXTERNAL_URL = `${window.location.protocol}//${window.location.host}/external-api/measurement/opentelemetry`;

export const startTracing = (spanFiltersConfigGetter, pushAppEvent) => {
    const tracerProvider = new WebTracerProvider({
        resource: new Resource({
            [ATTR_SERVICE_NAME]: TRACER_NAME,
            [SEMRESATTRS_SERVICE_NAME]: RESOURCE_NAME,
        }),
    });
    const collectorOptions = {
        url: OPEN_TELEMETRY_EXTERNAL_URL,
        headers: authTokenManager.getHeaders(),
    };
    const batchSpanProcessor = new BatchSpanProcessor(new OTLPTraceExporter(collectorOptions));
    tracerProvider.addSpanProcessor(batchSpanProcessor);
    tracerProvider.addSpanProcessor(
        new CustomSpanMetricProcessor(span => traceSpanMetricNormalize(span, spanFiltersConfigGetter), pushAppEvent)
    );

    tracerProvider.register({
        contextManager: new ZoneContextManager(),
        propagator: new CompositePropagator({
            propagators: [new W3CTraceContextPropagator()],
        }),
    });

    return { tracerProvider, batchSpanProcessor };
};
